if (!customElements.get('product-slider-dots')) {
  customElements.define(
    'product-slider-dots',
    class ProductSliderDots extends HTMLElement {
      constructor() {
        super();
        this.requestUpdate = this.requestUpdate.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handlePrevClick = () => this.goToIndex(this.activeIndex - 1);
        this.handleNextClick = () => this.goToIndex(this.activeIndex + 1);
        this.rafId = null;
        this.activeIndex = 0;
      }

      connectedCallback() {
        this.container = this.closest('product-images');
        this.slider = this.container?.querySelector('[data-product-media-list]');
        this.dots = [...this.querySelectorAll('[data-slider-dot]')];
        this.prevButton = this.container?.querySelector('[data-slider-prev]');
        this.nextButton = this.container?.querySelector('[data-slider-next]');

        if (!this.slider || !this.dots.length) return;

        this.slides = [...this.slider.querySelectorAll('[data-slide]')];

        this.slider.addEventListener('scroll', this.requestUpdate, {passive: true});
        document.addEventListener('theme:resize:width', this.requestUpdate);
        this.addEventListener('click', this.handleClick);
        this.prevButton?.addEventListener('click', this.handlePrevClick);
        this.nextButton?.addEventListener('click', this.handleNextClick);

        this.update();
      }

      disconnectedCallback() {
        this.slider?.removeEventListener('scroll', this.requestUpdate);
        document.removeEventListener('theme:resize:width', this.requestUpdate);
        this.removeEventListener('click', this.handleClick);
        this.prevButton?.removeEventListener('click', this.handlePrevClick);
        this.nextButton?.removeEventListener('click', this.handleNextClick);
        if (this.rafId) cancelAnimationFrame(this.rafId);
      }

      handleClick(event) {
        const dot = event.target.closest('[data-slider-dot]');
        if (!dot) return;
        this.goToIndex(this.dots.indexOf(dot));
      }

      goToIndex(index) {
        const slide = this.slides[Math.max(0, Math.min(this.slides.length - 1, index))];
        if (slide) this.slider.scrollTo({left: slide.offsetLeft, behavior: 'smooth'});
      }

      requestUpdate() {
        if (this.rafId) cancelAnimationFrame(this.rafId);
        this.rafId = requestAnimationFrame(() => this.update());
      }

      update() {
        this.rafId = null;

        const scrollLeft = this.slider.scrollLeft;
        let activeIndex = 0;
        let closestDistance = Infinity;

        this.slides.forEach((slide, index) => {
          const distance = Math.abs(slide.offsetLeft - scrollLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            activeIndex = index;
          }
        });

        this.activeIndex = activeIndex;
        this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex));

        if (this.prevButton) this.prevButton.disabled = activeIndex <= 0;
        if (this.nextButton) this.nextButton.disabled = activeIndex >= this.slides.length - 1;

        this.positionOnSlide(this.slides[activeIndex]);
      }

      positionOnSlide(slide) {
        const media = slide?.querySelector('.product__photo, .product__media');
        if (!media) return;
        const mediaBottom = this.slider.offsetTop + media.offsetTop + media.offsetHeight;
        this.style.setProperty('--dots-top', `${mediaBottom}px`);
        this.classList.add('is-positioned');
      }
    }
  );
}
